import {getStartOfWeek} from '@igp/shared/utils';

export const agentLevelReportV2ServiceTypes = {
    service: Symbol('AgentLevelReportV2Service'),
    downloadClientStrategy: Symbol('AgentLevelReportV2DownloadClientStrategy'),
    downloadServerStrategy: Symbol('AgentLevelReportV2DownloadServerStrategy'),
} as const;

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);

export const CommissionSubTypesTypeName = 'CommissionSubTypes';
export const CommissionSubTypesHistoryViewModelTypeName = 'CommissionSubTypesHistoryViewModel';
export const AgentLevelReportV2DownloadViewModelsKeysTypeName = 'AgentLevelReportV2DownloadViewModelsKeys';
